














import { Component, Prop, Vue } from "vue-property-decorator";

@Component
/**
 * Show a skeleton for the dashboard
 */
export default class DashboardSkeleton extends Vue {
  /**
   * show skeleton boolean
   */
  @Prop({ required: true }) readonly show!: boolean;

  /**
   * define how many skeleton parts are shown
   */
  @Prop({ required: false, default: 3 }) skeletonNumber!: number;
}
